<template>
  <div class="m-market-handicap">
    <div class="m-market-row">
      <div
        v-for="(title) in marketTitles"
        :key="title"
        class="m-title"
      >
        {{ title }}
      </div>
    </div>
    <Market10HandicapItem
      v-for="(item, index) in sortedMarkets"
      :key="index"
      class="m-market-row"
      :event="event"
      :market="item"
    />
  </div>
</template>

<script>
/**
 * 1. 按Home、Away 显示2列
 * 2. 将Outcome Description的数字部分提取出来：作为outcome名称，如-10.5, +10.5
 * 3. 相同Market ID、不同specifier的outcome显示在同一个Market下，按照接口返回的specifier顺序排序
 */
import useMarket10Handicap from '@ms/components/market/useMarket10Handicap.js'
import Market10HandicapItem from './Market10HandicapItem.vue'

export default {
  components: {
    Market10HandicapItem
  },
  props: {
    markets: {
      type: Array,
      default: () => []
    },
    event: {
      type: Object,
      default: () => ({})
    }
  },
  setup(props) {
    const { marketTitles, sortedMarkets } = useMarket10Handicap(props)

    return {
      marketTitles,
      sortedMarkets
    }
  }
}
</script>

<style lang="less">
.m-market-handicap {
  .m-market-row {
    margin: 0 0 4px;

    .m-title {
      padding: 4px 0;
      color: #ccc;
      font-size: 12px;
    }

    .m-outcome {
      width: 100%;
      flex: 1;

      .desc {
        color: #999;
      }

      &.active {
        .desc {
          color: #666;
        }
      }
    }
  }
}
</style>
